import { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "utils/@reduxjs/toolkit";
import { useInjectReducer } from "utils/redux-injectors";
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery, endpoints, formatErrors } from "utils/api/endpoints";
import { PracticeInfoState } from "./types";


export const initialState: PracticeInfoState = {
  loading: false,
  error: null,
  practiceInfo: null,
};

// RTK Query API for login
export const api = createApi({
  reducerPath: 'practiceApi',
  baseQuery,
  tagTypes: ['PracticeInfo'],
  endpoints: (builder) => ({
    practiceInfo:  builder.mutation<any, any>({
      query: (body) => ({
        url: endpoints.addPracticeInfo.url,
        method: endpoints.addPracticeInfo.method,
        body: body,
      }),
      transformResponse: (response: any) => response || [],
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return formatErrors(baseQueryReturnValue.data);
      },
      invalidatesTags: ['PracticeInfo'],
    }),

    practiceInfoGet:  builder.query<any, any>({
      query: () => ({
        url: endpoints.practiceInfo.url,
        method: endpoints.practiceInfo.method,
      }),
      transformResponse: (response: any) => response || [],
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return formatErrors(baseQueryReturnValue.data);
      },
      providesTags: ['PracticeInfo'],
    }),
  })
})


const slice = createSlice({
  name: "practice",
  initialState,
  reducers: {
    someAction(state, action: PayloadAction<any>) {},
  },
});

export const { actions: practiceInfoActions, reducer: practiceInfoReducer } = slice;

export const usePracticeInfoSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });

  // RTK Query injects itself
  return {
    actions: slice.actions,
    ...api,
  };  
};

export const { usePracticeInfoMutation, usePracticeInfoGetQuery } = api;

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
